import { lazy } from "react";

const J33vesRoutes = [
    {
        path: "/j33ves",
        component: lazy(() => import("../../views/j33ves")),
        title: "J33ves",
    },
];

export default J33vesRoutes;
